import http from '@/utils/http';

// 学校数
export const getSchoolTotal = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/school/all',
        method: 'get',
        params
    })
}
//  今年教师人数
export const getTeacherTotal = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/teacher/all',
        params
    })
}
// 资源文件上传数量
export const getFileNums = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/resourcesSupport',
        params
    })
}
// 学校设备数量统计
export const getDeviceNums = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/device',
        params
    })
}